import { initReactI18next } from 'react-i18next';
import I18nBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

// Internal
// --------

i18n
  .use(I18nBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json?v=13`, // bust cache by bumping version
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    load: 'languageOnly',
    ns: 'common',
    react: {
      useSuspense: false,
    },
    supportedLngs: ['en'],
  });

// Exports
// -------

export default i18n;
